import styles from './Toggle.module.scss';

interface IToggleProps {
  isActive: boolean;
  label: string;
  onChange: () => void;
}

function Toggle({ isActive, label, onChange }: IToggleProps) {
  return (
    <div className={styles.toggle}>
      <label className={styles.switch}>
        <input type="checkbox" checked={isActive} onChange={onChange} />
        <span className={styles.slider} />
      </label>
      <span>{label}</span>
    </div>
  );
}

export default Toggle;
